import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';
import { SendType } from 'interfaces';

export type EmailHistory = {
  email_history_id?: number; // 이메일 내역 idx
  email_history?: { [key: string]: Record<string, any> };
  type?: (typeof SendType)[keyof typeof SendType]; // 타입
  created_at?: number; // 생성일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] EmailHistory
   * --
   */
  getEmailHistories: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GET_EMAIL_HISTORIES, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] EmailHistory
   * --
   */
  getEmailHistory: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_EMAIL_HISTORY, {
        email_history_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] EmailHistory
   * --
   */
  createEmailHistory: async (body: EmailHistory) => {
    try {
      const res = await $http.post(APIConstant.CREATE_EMAIL_HISTORY, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] EmailHistory
   * --
   */
  updateEmailHistory: async (body: EmailHistory) => {
    try {
      const { email_history_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_EMAIL_HISTORY, {
        email_history_id: email_history_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] EmailHistory
   * --
   */
  deleteEmailHistory: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_EMAIL_HISTORY, {
        email_history_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
